import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-user-details-view',
  templateUrl: './user-details-view.component.html',
  styleUrls: ['./user-details-view.component.scss']
})
export class UserDetailsViewComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
